export const environment = {
    production: true,
    rootPath: '/api',
    domainPrefix: '',
    copyright: '©$YEAR$ CER Monti Azzurri',
    address: 'Via Trento e Trieste, snc – 62026 San Ginesio (MC)',
    forbiddenWords: ['admin', 'default', 'member', 'root', 'test', 'user']
};
